
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var extend = require('extend'),
    serializeIdentified = require('./serializeIdentified'),
    serializeComponent = require('./serializeComponent'),
    serializeSequenceAnnotation = require('./serializeSequenceAnnotation'),
    serializeSequenceConstraint = require('./serializeSequenceConstraint');

module.exports = function serializeComponentDefinition(sbolDocument, componentDefinition) {

    var out = {};

    if(componentDefinition.types.length > 0) {
        out.types = componentDefinition.types.map(function(type) {
            return type.toString();
        });
    }

    if(componentDefinition.roles.length > 0) {
        out.roles = componentDefinition.roles.map(function(role) {
            return role.toString();
        });
    }

    if(componentDefinition.components.length > 0) {
        out.components = componentDefinition.components.map(function(component) {
            return serializeComponent(sbolDocument, component);
        });
    }

    if(componentDefinition.sequenceAnnotations.length > 0) {
        out.sequenceAnnotations = componentDefinition.sequenceAnnotations.map(function(sequenceAnnotation) {
            return serializeSequenceAnnotation(sbolDocument, sequenceAnnotation);
        });
    }

    if(componentDefinition.sequenceConstraints.length > 0) {
        out.sequenceConstraints = componentDefinition.sequenceConstraints.map(function(sequenceConstraint) {
            return serializeSequenceConstraint(sbolDocument, sequenceConstraint);
        });
    }

    if(componentDefinition.sequences.length > 0) {
        out.sequences = componentDefinition.sequences.map(function(sequence) {
            return sequence.uri?sequence.uri.toString():sequence.toString();
        });
    }

    return extend(serializeIdentified(sbolDocument, componentDefinition), out);
}

